import React from 'react';
import { withRouter } from 'react-router-dom';
import classNames from "classnames";

import SideNavItems from 'Components/Partials/Layouts/SideNavItems';

import { Scopes } from 'Services';

import adminScopes from 'Config/Scopes/Admin';

/**
 * @classdesc Side Nav Bar
 */
class SideNav extends React.Component {
    /**
     * @var state
     */
    state = {
        collapse: false,
    };

    /**
     * @method adminMode
     * @return {boolean}
     */
    get adminMode() {
        return this.activeLink('/admin', true) && Scopes.has(adminScopes);
    }

    /**
     * @method activeLink
     * @param {string} location
     * @param {boolean} starts
     * @return {boolean|*}
     */
    activeLink = (location, starts = false) => {
        if (starts) {
            return this.props.location.pathname.startsWith(location);
        }

        return this.props.location.pathname === location;
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const { holidayApprovals, overtimeApprovals, suspendedStockPending, accidentLog, collapse } = this.props;

        return (
            <React.Fragment>
                <div className={classNames("md:flex-shrink-0 transition-all duration-200", {
                    '-ml-56': collapse,
                })}>
                    <div className="bg-app-blue-dark flex flex-col w-56 h-full">
                        <div className="h-0 flex-1 flex flex-col overflow-y-auto">
                            <SideNavItems
                                type={this.adminMode ? 'admin' : 'normal'}
                                holidayApprovals={holidayApprovals}
                                overtimeApprovals={overtimeApprovals}
                                suspendedStockPending={suspendedStockPending}
                                accidentLog={accidentLog}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(SideNav);
